import axios from "axios";
import { configUrl } from "../../config";

const getUserTopicsForTests = async (userId) => {
    let response = await axios.get(
        `${configUrl.AssessmentServer}/api/UserSubscription/getUserTopicsForTests/${userId}`
    );
    let data = response?.data;


    return data;
};

const getTestSubscriptionDetails = async (userId) => {
    try {
        let response = await axios.get(
            `${configUrl.AssessmentServer}/api/UserSubscription/getTestSubscriptionDetails/${userId}`
        );
        console.log("subscription data", response);

        let data = response?.data;


        return data;
    } catch (error) {

        // No subscription found
        if (error?.response?.status === 404) {
            console.warn(
                `No test subscription found for user ${userId}`
            );

            return null;
        }

        throw error;
    }
};

const getCourseSubscriptionDetails = async (userId) => {
    let response = await axios.get(
        `${configUrl.AssessmentServer}/api/UserSubscription/getCourseSubscription/${userId}`
    );
    let data = response?.data;


    return data;
};


export default {
    getUserTopicsForTests: getUserTopicsForTests,
    getTestSubscriptionDetails: getTestSubscriptionDetails,
    getCourseSubscriptionDetails: getCourseSubscriptionDetails

}